import React from 'react';
import './IndiaVerdict.css';
import Statistics from './Statistics';
import UseCases from './UseCases';
import LegalInfo from './LegalInfo';
import RequestInfo from '../RequestInfo/RequestInfo';
import Divider from '../VerticalsWePower/Divider';
import { Helmet } from 'react-helmet-async';
import featureFlags from '../../configuration/featureFlags';
import siteConfig from '../../configuration/siteConfiguration';

export const LEGAL_PRODUCT_NAME = 'Cognitva Legal';

const cardData = [
  {
    id: 1,
    title: 'AI-Powered Legal Research',
    icon: 'ai-powered-legal-research.svg',
  },
  {
    id: 2,
    title: 'Role Play & Virtual Courtroom Simulation',
    icon: 'role-play--virtual-courtroom-simulation.svg',
  },
  {
    id: 3,
    title: 'Smart Client & Matter Management',
    icon: 'smart-client--matter-management.svg',
  },
  {
    id: 4,
    title: 'Compliance, Risk, and Regulatory Monitoring',
    icon: 'compliance-risk-and-regulatory-monitoring.svg',
  },
  {
    id: 5,
    title: 'AI-Driven Knowledge Management',
    icon: 'ai-driven-knowledge-management.svg',
  },
  {
    id: 6,
    title: 'Intelligent Contract Lifecycle Management (CLM)',
    icon: 'intelligent-contract-lifecycle-management-clm.svg',
  },
  {
    id: 7,
    title: 'Analytics & Insights Dashboards',
    icon: 'analytics--insights-dashboards.svg',
  }
];

const IndiaVerdict = () => {
  const leftCards = cardData.slice(0, 3);
  const rightCards = cardData.slice(3, 7);

  return (
    <div className="indiaverdict-section">
      <div className="indiaverdict-left">
        <div className="indiaverdict-label-row">
          <span className="indiaverdict-label-line"></span>
          <span className="indiaverdict-label">{LEGAL_PRODUCT_NAME}</span>
        </div>
        <h2 className="indiaverdict-title">Where Cognitva legal transforms your practice</h2>
        <p className="indiaverdict-desc">
          AI powered Legal Research, Contract automation, litigation intelligence, compliance copilots — all built for law firms, corporates, and courts
        </p>
        <ul className="indiaverdict-benefits">
          <li>
            <img className="indiaverdict-icon" src="/images/countdown2.svg" alt="Countdown Icon" />
            10x-15x faster legal research and case strategy formulation
          </li>
          <li className="indiaverdict-single-line">
            <img className="indiaverdict-icon" src="/images/sidebaricons.svg" alt="Sidebar Icon" />
            70% increase in document retrieval speed with AI search and auto-tagging
          </li>
        </ul>
        {featureFlags.legal.showDemoLink &&
          <div className="indiaverdict-buttons">
            <button className="indiaverdict-btn primary">
              <span className="indiaverdict-btn-primary-text">Get started</span>
              <span className="indiaverdict-btn-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M14 6.5C14 6.63261 13.9473 6.75979 13.8536 6.85355C13.7598 6.94732 13.6326 7 13.5 7C13.3674 7 13.2402 6.94732 13.1464 6.85355C13.0527 6.75979 13 6.63261 13 6.5V3.7075L8.85437 7.85375C8.76055 7.94757 8.63331 8.00028 8.50062 8.00028C8.36794 8.00028 8.2407 7.94757 8.14688 7.85375C8.05305 7.75993 8.00035 7.63268 8.00035 7.5C8.00035 7.36732 8.05305 7.24007 8.14688 7.14625L12.2925 3H9.5C9.36739 3 9.24021 2.94732 9.14645 2.85355C9.05268 2.75979 9 2.63261 9 2.5C9 2.36739 9.05268 2.24021 9.14645 2.14645C9.24021 2.05268 9.36739 2 9.5 2H13.5C13.6326 2 13.7598 2.05268 13.8536 2.14645C13.9473 2.24021 14 2.36739 14 2.5V6.5ZM11.5 8C11.3674 8 11.2402 8.05268 11.1464 8.14645C11.0527 8.24021 11 8.36739 11 8.5V13H3V5H7.5C7.63261 5 7.75979 4.94732 7.85355 4.85355C7.94732 4.75979 8 4.63261 8 4.5C8 4.36739 7.94732 4.24021 7.85355 4.14645C7.75979 4.05268 7.63261 4 7.5 4H3C2.73478 4 2.48043 4.10536 2.29289 4.29289C2.10536 4.48043 2 4.73478 2 5V13C2 13.2652 2.10536 13.5196 2.29289 13.7071C2.48043 13.8946 2.73478 14 3 14H11C11.2652 14 11.5196 13.8946 11.7071 13.7071C11.8946 13.5196 12 13.2652 12 13V8.5C12 8.36739 11.9473 8.24021 11.8536 8.14645C11.7598 8.05268 11.6326 8 11.5 8Z" fill="white" />
                </svg>
              </span>
            </button>
            <button className="indiaverdict-btn secondary">
              <span className="indiaverdict-btn-secondary-text">Live demo</span>
            </button>
          </div>}
      </div>
      <div className="indiaverdict-right">
        <div className="indiaverdict-columns-animate">
          <div className="indiaverdict-column indiaverdict-column-down">
            {leftCards.concat(leftCards).map((card, idx) => (
              <div
                key={'down-' + idx + '-' + card.id}
                className={`indiaverdict-card${card.faded ? ' faded' : ''}${card.highlighted ? ' highlighted' : ''}`}
              >
                <div className="indiaverdict-card-icon">
                  <img src={`${siteConfig.assetBaseUrl}/icons/legal/hero-section---indiaverdict.ai/${card.icon}`} alt="feature icon" />
                </div>
                <div className="indiaverdict-card-title">{card.title}</div>
              </div>
            ))}
          </div>
          <div className="indiaverdict-column indiaverdict-column-up">
            {rightCards.concat(rightCards).map((card, idx) => (
              <div
                key={'up-' + idx + '-' + card.id}
                className={`indiaverdict-card${card.faded ? ' faded' : ''}${card.highlighted ? ' highlighted' : ''}`}
              >
                <div className="indiaverdict-card-icon">
                  <img src={`${siteConfig.assetBaseUrl}/icons/legal/hero-section---indiaverdict.ai/${card.icon}` || "/images/icons.svg"} alt="feature icon" />
                </div>
                <div className="indiaverdict-card-title">{card.title}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default function IndiaVerdictWithStats() {
  return (
    <>
      <Helmet>
        <title>Legal Solution - Cognitva Global Technologies Private Limited</title>
        <meta name="description" content="Explore how Cognitva Legal transforms legal practice in India with AI-powered solutions for law firms, corporates, and courts." />
        <meta name="keywords" content="Cognitva, India Verdict, Legal AI, Law Firms, Corporate Law, Court Solutions" />
        <link rel="canonical" href="https://www.cognitva.ai/india-verdict" />
        <meta property="og:title" content="Cognitva Global Technologies Private Limited - India Verdict" />
        <meta property="og:description" content="Explore how Cognitva Legal transforms legal practice in India with AI-powered solutions for law firms, corporates, and courts." />
        <meta property="og:url" content="https://www.cognitva.ai/india-verdict" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://www.cognitva.ai/images/cognitva-logo.png" />
        <meta property="og:image:alt" content="Cognitva Logo" />
        <meta property="og:site_name" content="Cognitva Global Technologies Private Limited" />
      </Helmet>
      <IndiaVerdict />
      <Divider />
      <Statistics />
      <UseCases />
      {featureFlags.legal.showWhatYouCanAccomplish && <LegalInfo />}
      <Divider />
      <RequestInfo />
    </>
  );
} 